/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FontFamilyFromJSON, FontFamilyToJSON } from './FontFamily';
import { TextAlignmentFromJSON, TextAlignmentToJSON } from './TextAlignment';
export function UpdateSiteSectionRequestSiteSectionFromJSON(json) {
    return UpdateSiteSectionRequestSiteSectionFromJSONTyped(json, false);
}
export function UpdateSiteSectionRequestSiteSectionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        name: !exists(json, 'name') ? undefined : json['name'],
        titleAlignment: !exists(json, 'title_alignment') ? undefined : TextAlignmentFromJSON(json['title_alignment']),
        titleFontFamily: !exists(json, 'title_font_family') ? undefined : FontFamilyFromJSON(json['title_font_family']),
        titleFontSize: !exists(json, 'title_font_size') ? undefined : json['title_font_size'],
        titleTextColor: !exists(json, 'title_text_color') ? undefined : json['title_text_color']
    };
}
export function UpdateSiteSectionRequestSiteSectionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        name: value.name,
        title_alignment: TextAlignmentToJSON(value.titleAlignment),
        title_font_family: FontFamilyToJSON(value.titleFontFamily),
        title_font_size: value.titleFontSize,
        title_text_color: value.titleTextColor
    };
}
